import React from 'react';
import { CheckCircle2, AlertCircle } from 'lucide-react';
export function Comparison() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto" data-id="element-2">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight" data-id="element-4">
            Do You Need New Windows — or Just New Glass?
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10" data-id="element-5">
          {/* Left Card */}
          <div className="bg-glassBlue-50 rounded-2xl p-8 border border-glassBlue-100" data-id="element-6">
            <h3 className="text-2xl font-bold text-navy-900 mb-6 flex items-center gap-3" data-id="element-7">
              <CheckCircle2 className="w-8 h-8 text-brandBlue-600" data-id="element-8" />
              Glass-only replacement may be right when…
            </h3>
            <ul className="space-y-4" data-id="element-9">
              {['The window frame is still solid and operating properly', 'The glass is cracked, broken or shattered', 'A double-pane unit is foggy or has condensation between panes', 'The insulated glass seal has failed but the window frame is still usable', 'You want to upgrade to Low-E or insulated glass without replacing the whole window', 'You want a cost-effective repair before committing to full window replacement'].map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-10">
                  <div className="w-2 h-2 rounded-full bg-brandBlue-500 mt-2.5 flex-shrink-0" data-id="element-11" />
                  <span className="text-slate-700 text-lg" data-id="element-12">{bullet}</span>
                </li>)}
            </ul>
          </div>

          {/* Right Card */}
          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200" data-id="element-13">
            <h3 className="text-2xl font-bold text-navy-900 mb-6 flex items-center gap-3" data-id="element-14">
              <AlertCircle className="w-8 h-8 text-slate-500" data-id="element-15" />
              Full window replacement may be better when…
            </h3>
            <ul className="space-y-4" data-id="element-16">
              {['The frame is rotted, warped or damaged', 'The window no longer opens, closes or locks correctly', 'Water is entering around the frame or wall', 'The sash or frame structure is failing', 'Multiple window components are damaged', 'You want to change the window size, style or full window system'].map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-17">
                  <div className="w-2 h-2 rounded-full bg-slate-400 mt-2.5 flex-shrink-0" data-id="element-18" />
                  <span className="text-slate-700 text-lg" data-id="element-19">{bullet}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="max-w-3xl mx-auto text-center" data-id="element-20">
          <p className="text-slate-600 mb-8 italic" data-id="element-21">
            Kosin’s Glass can inspect your window glass and explain whether
            repair, glass replacement or full window replacement makes the most
            sense.
          </p>
          <a href="#estimate-form" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-22">
            Ask About Glass-Only Replacement
          </a>
        </div>
      </div>
    </section>;
}